import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import AiMyprDialog from '@/components/format-edit/AiMyprDialog.vue'
import AiMyprDialogHeader from '@/components/format-edit/AiMyprDialogHeader.vue'
import AiMyprPrQuestionsForm from '@/components/format-edit/AiMyprPrQuestionsForm.vue'
import { useAiMyprDialogControls } from '@/composables/format-edit/useAiMyprDialogControls'
import { useDesignRirekishoAiMypr } from '@/composables/format-edit/useDesignRirekishoAiMypr'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import {
  useRirekishoFormatData,
  type RirekishoExampleSentence,
  type RirekishoExampleSentences
} from '@/composables/format-edit/useRirekishoFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'DesignRirekishoMyprCard',
  props: {
    currentCardId: null,
    exampleSentences: null,
    textareaMinRows: null,
    previewErrors: null,
    enableAi: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { currentCardId?: string, exampleSentences?: RirekishoExampleSentences, textareaMinRows: number, previewErrors: Record<string, string>, enableAi: boolean };



const formatData = useRirekishoFormatData()
const { globalVar } = useHostServices()
const exampleVisible = ref(false)
const myprExamples = computed(() => props.exampleSentences?.mypr || [])
const inAppPayments = computed(
  () =>
    !!(globalVar as typeof globalVar & { in_app_payments?: boolean })
      .in_app_payments
)

const { aiMyprVisible, openAiMyprDialog, closeAiMyprDialog } =
  useAiMyprDialogControls()

const {
  useDigram,
  fullscreenLoading,
  aiResultView,
  aiResultMyprResult,
  getAIMypr,
  goYagiprimeRegister,
  applyAiResultToMypr
} = useDesignRirekishoAiMypr(formatData)

function onSelectExample(item: RirekishoExampleSentence) {
  formatData.mypr = item.description.replace(/<br>/gi, '\n')
}

return { __sfc: true,props, formatData, globalVar, exampleVisible, myprExamples, inAppPayments, aiMyprVisible, openAiMyprDialog, closeAiMyprDialog, useDigram, fullscreenLoading, aiResultView, aiResultMyprResult, getAIMypr, goYagiprimeRegister, applyAiResultToMypr, onSelectExample, NewRirekishoExampleSentenceDialog, AiMyprDialog, AiMyprDialogHeader, AiMyprPrQuestionsForm }
}

})